import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { PaginationProps } from 'types/paginationAndFilter';
import { objectToQueryParams } from 'utils/linkUtil';

/**
 * A report endpoint in the list table's fetch shape. A report answers every row in one page, so only the filter
 * and the sort go out; the paging the table sends is not needed.
 */
export function reportQuery<Response>(
    builder: EndpointBuilder<
        BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, Record<string, unknown>, FetchBaseQueryMeta>,
        string,
        'portalAPI'
    >,
    endpoint: string
) {
    return builder.query<Response, PaginationProps>({
        query: ({ filters, passiveFilters, sort }) =>
            `${endpoint}${objectToQueryParams({
                filter: [passiveFilters, filters].filter(Boolean).join(';') || undefined,
                sort: sort || undefined,
            })}`,
        keepUnusedDataFor: 0,
    });
}
